import { isNitroEnvironment } from 'utils/is-nitro-env';
let datadogRum = null;
let initPromise = null;
export const shouldInitDatadogRum = ()=>window.location.hostname.includes('leadsquared') || isNitroEnvironment();
export const initDatadogRumAsync = (config)=>{
    if (!shouldInitDatadogRum() || !config.applicationId) {
        return Promise.resolve(null);
    }
    if (datadogRum) {
        return Promise.resolve(datadogRum);
    }
    if (initPromise) {
        return initPromise;
    }
    initPromise = import('@datadog/browser-rum').then((module)=>{
        module.datadogRum.init({
            ...config,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            // Preserve pre-upgrade (browser-rum v4) Session Replay privacy:
            // v4 defaulted to mask-user-input; v7 also defaults to that, but set
            // it explicitly so a future SDK default change cannot loosen/tighten us.
            defaultPrivacyLevel: 'mask-user-input',
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            excludedActivityUrls: [
                /\/r.lr-in-prod.com$/,
                /\/backend.getbeamer.com$/,
                /\/.pusher.com$/
            ]
        });
        datadogRum = module.datadogRum;
        return datadogRum;
    });
    return initPromise;
};
export const getDatadogRum = ()=>{
    if (datadogRum) {
        return Promise.resolve(datadogRum);
    }
    if (initPromise) {
        return initPromise;
    }
    return Promise.resolve(null);
};
export const getSessionReplayLink = ()=>getDatadogRum().then((rum)=>rum === null || rum === void 0 ? void 0 : rum.getSessionReplayLink());
export const addDatadogRumError = (error, context)=>{
    getDatadogRum().then((rum)=>{
        rum === null || rum === void 0 ? void 0 : rum.addError(error, context);
    }).catch(()=>undefined);
};
export const addDatadogRumTiming = (name, duration)=>{
    getDatadogRum().then((rum)=>{
        rum === null || rum === void 0 ? void 0 : rum.addTiming(name, duration);
    }).catch(()=>undefined);
};
export const setDatadogRumUser = (userInfo)=>{
    getDatadogRum().then((rum)=>{
        rum === null || rum === void 0 ? void 0 : rum.setUser(userInfo);
    }).catch(()=>undefined);
};
